import SettingItemTextV4 from './SettingItemTextV4';
import SwitchToggleV4 from './SwitchToggleV4';
import {ISettingItemTextType} from '../type';

interface IProps {
  topText: string;
  topTextType?: ISettingItemTextType;
  bottomText?: string;
  bottomTextType?: ISettingItemTextType;
  onChange: () => void;
  isChecked: boolean;
  disabled?: boolean;
  iconSrc?: string;
}

export default function SettingItemToggleV4({
  topText,
  topTextType,
  bottomText,
  bottomTextType,
  onChange,
  isChecked,
  disabled = false,
  iconSrc,
}: IProps) {
  return (
    <div className="flex justify-between items-center p-18">
      <div>
        <div className="flex items-center">
          {iconSrc && <img src={iconSrc} className="w-20 h-20 mr-8" alt="" />}
          <SettingItemTextV4 text={topText} type={topTextType} />
        </div>
        {bottomText && (
          <SettingItemTextV4 text={bottomText} type={bottomTextType} />
        )}
      </div>
      <div>
        <SwitchToggleV4
          disabled={disabled}
          isChecked={isChecked}
          onChange={onChange}
        />
      </div>
    </div>
  );
}
